import { useState } from "react";
import { Controller } from "react-hook-form";
import {
  Group,
  FileButton,
  Button,
  LoadingOverlay,
  Flex,
  Text,
  Tooltip,
} from "@mantine/core";

import { useFileUpload } from "../services/react-query";
import { notifications } from "@mantine/notifications";

const PDFUpload = ({ control, name, label, description, ...props }) => {
  const [fileName, setFileName] = useState(null);

  const { isPending, mutateAsync } = useFileUpload();

  const handlePDFUpload = async (file, onChange) => {
    if (!file) return;

    if (file.type !== "application/pdf") {
      notifications.show({
        title: "Invalid file type",
        message: "Please upload a PDF file.",
        color: "red",
        autoClose: 3000,
      });
      return;
    }

    const data = await mutateAsync(file);
    onChange(data.fileKey);
    setFileName(file.name);
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange }, fieldState: { error } }) => (
        <Flex direction="column" {...props}>
          {label && (
            <Text size="sm" fw={600} mb={description ? 0 : "sm"}>
              {label}
            </Text>
          )}
          {description && (
            <Text size="xs" c="dimmed" style={{ marginBottom: 10 }}>
              {description}
            </Text>
          )}
          <Group>
            <Flex pos="relative" align="center">
              <LoadingOverlay visible={isPending} />
              {fileName && (
                <>
                  <Tooltip label="Uploaded file" withArrow>
                    <Text size="sm" fw={500}>
                      {fileName}
                    </Text>
                  </Tooltip>
                  <Button
                    variant="subtle"
                    size="xs"
                    color="red"
                    onClick={() => {
                      setFileName(null);
                      onChange("");
                    }}
                    style={{ marginLeft: 10 }}
                  >
                    Remove
                  </Button>
                </>
              )}

              {!fileName && (
                <FileButton
                  onChange={(payload) => handlePDFUpload(payload, onChange)}
                  accept="application/pdf"
                >
                  {(props) => (
                    <Button size="compact-md" variant="light" {...props}>
                      Select file
                    </Button>
                  )}
                </FileButton>
              )}
            </Flex>
          </Group>
          {error && (
            <Text size="xs" c="red" mt={5} fw="500">
              {error.message}
            </Text>
          )}
        </Flex>
      )}
    />
  );
};

export default PDFUpload;
